import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { VendorContactComponent } from './vendor-contact.component';
import { UpdateContactComponent } from './update-contact/update-contact.component';

const routes: Routes = [{ path: '', component: VendorContactComponent },
{ path: 'updatecontact', component: UpdateContactComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class VendorContactRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/pages/vendor/my-vendor/vendor-contact/vendor-contact-routing.module.ts